import React from 'react';

import * as commonApi from '../../api/common-api';

var Modal = require('react-modal');
const customStyles = {
	overlay : {
    position          : 'fixed',
    top               : 0,
    left              : 0,
    right             : 0,
    bottom            : 0,
    backgroundColor   : 'rgba(0, 0, 0, 0.3)',
    zIndex 				  : '999',
    overflow: 'auto'
 },
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    marginRight           : '-50%',
    transform             : 'translate(-50%, -50%)',
    zIndex 				  : '999'
  }
};
class POPUP extends React.Component{
	constructor(props) {
    super(props);
    this.state = {overlayClick:false,style:customStyles};
  }
  


	componentDidMount() {
	if(this.props.overlayClick != undefined)
		this.setState({overlayClick:this.props.overlayClick})
		if(this.props.style != undefined)
		this.setState({style:this.props.style})
		
	}

	componentWillReceiveProps(nextProps) {
		if(nextProps.style != undefined)
		this.setState({style:nextProps.style})
	}
	
  closeModal() {
	    this.props.onClose();
	  }
  
  	
	
	
	render() {
		
    return (
    	<Modal
		          isOpen={this.props.show}
					onRequestClose={this.closeModal.bind(this)}
		          style={this.state.style}
		          shouldCloseOnOverlayClick={this.props.overlayClick}
                  contentLabel=""
		           >
		
		          {this.props.content}

		        </Modal>
      
    )
  }
}

export default POPUP;


/** WEBPACK FOOTER **
 ** ./src/client/app/eappcomponents/commons/popup.js
 **/